/** Revenue Recovery's monthly fee, cents. The modal never offers another. */
export const REVENUE_RECOVERY_FEE = 2900;

/** The backend's bounds for `vOrdersPerOrderFee`, cents ($0.01-$5). */
export const PER_ORDER_FEE_MIN = 1;
export const PER_ORDER_FEE_MAX = 500;

/** The same for `vOrdersPerDayFee`. */
export const PER_DAY_FEE_MIN = 1;
export const PER_DAY_FEE_MAX = 500;

/**
 * How vTablet is billed: the monthly fee by ACH, an amount withheld from
 * every virtual-brand order payout, or an amount a day from the vGrubs
 * balance. One at a time.
 */
export type VTabletBillingMode = 'monthly' | 'perOrder' | 'perDay';

export const billingModeFor = (salesConfig?: {
  vOrdersPerOrderFee?: number | null;
  vOrdersPerDayFee?: number | null;
}): VTabletBillingMode =>
  salesConfig?.vOrdersPerDayFee != null
    ? 'perDay'
    : salesConfig?.vOrdersPerOrderFee != null
    ? 'perOrder'
    : 'monthly';

/**
 * The amount a day that adds up to the monthly fee in 30 days, rounded up:
 * $89 -> $2.97.
 */
export const perDayForMonthly = (monthlyFee: number) =>
  Math.ceil(monthlyFee / 30);

type ServicesTotalInput = {
  /** The monthly vTablet fee picked, cents; null while none is. */
  vTabletFee: number | null | undefined;
  /**
   * vTablet billed per order or per day: its monthly fee is not part of the
   * total.
   */
  billing: VTabletBillingMode;
  /** The inputs hold strings while typing, the saved config numbers. */
  extraTablets: number | string;
  extraTabletPrice: number | undefined;
  extraPrinters: number | string;
  extraPrinterPrice: number | undefined;
  vRevenueService: boolean;
};

/**
 * What the location's monthly services add up to: the Total Amount as long as
 * nobody typed one in by hand. vTablet billed per order or per day is left
 * out, the same way the backend leaves it out of the total it computes.
 */
export const servicesMonthlyTotal = ({
  vTabletFee,
  billing,
  extraTablets,
  extraTabletPrice,
  extraPrinters,
  extraPrinterPrice,
  vRevenueService,
}: ServicesTotalInput) =>
  (vTabletFee && billing === 'monthly' ? vTabletFee : 0) +
  (Number(extraTablets) || 0) * (extraTabletPrice ?? 0) +
  (Number(extraPrinters) || 0) * (extraPrinterPrice ?? 0) +
  (vRevenueService ? REVENUE_RECOVERY_FEE : 0);
